module.exports = __webpack_public_path__ + "img/gs-img-4_en.270e47cb.png";